/**REGISTER ESIGNATURE USER */
export const REGISTER_CLEAR_DATA = "REGISTER_CLEAR_DATA";
export const REGISTER = "REGISTER";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_ERROR = "REGISTER_ERROR";
/**END */

/* Page login
list API's*/
export const LOGIN_CLEAR_DATA = "LOGIN_CLEAR_DATA";
export const LOGIN = "LOGIN";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";
/* Page login
END*/

//Forget password
export const FORGET_PASSWORD = "FORGET_PASSWORD";
export const FORGET_PASSWORD_SUCCESS = "FORGET_PASSWORD_SUCCESS";
export const FORGET_PASSWORD_ERROR = "FORGET_PASSWORD_ERROR";

//reset password from forgot password
export const RESET_PASSWORD = "RESET_PASSWORD";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_ERROR = "RESET_PASSWORD_ERROR";

export const RESET_APP = "RESET_APP";

//Hash Validation
export const HASH_VALIDATE = "HASH_VALIDATE";
export const HASH_VALIDATE_SUCCESS = "HASH_VALIDATE_SUCCESS";
export const HASH_VALIDATE_ERROR = "HASH_VALIDATE_ERROR";
